import * as React from "react";
import { CommonConstants } from "../common/constants/common-constants";
import { IListItem } from "../common/interfaces/list-item";
import { IAPIResponse, IHTTPResponse } from "../common/models/httpModels";
import { HTTPService } from "../common/services/httpService";
import { ISchoolModel, ISchoolSummaryModel, ISMSTemplate } from "./models/ISchoolModel";

const httpService = new HTTPService();

const getSchoolsList = (): Promise<IHTTPResponse<IAPIResponse<ISchoolModel>>> => {
  const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.ListSchools}`;
  return httpService.get(url);
};

const getSchoolsSummary = (): Promise<IHTTPResponse<IAPIResponse<ISchoolSummaryModel>>> => {
  const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.SchoolsSummary}`;
  return httpService.get(url);
};
const getSmsTemplates = (): Promise<IHTTPResponse<IAPIResponse<ISMSTemplate>>> => {
  const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.SmsTemplates}`;
  return httpService.get(url);
};
const sendSMS = (file: File, template: ISMSTemplate): Promise<IHTTPResponse<IAPIResponse<ISchoolSummaryModel>>> => {
  const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.SendSMS}/${template.templateId}`;
  const formData = new FormData();
  formData.append('files', file);
  return httpService.fileUpload(url, formData);
};



const FacilitatorService = {
  getSchoolsList,
  getSchoolsSummary,
  getSmsTemplates,
  sendSMS
};

export default FacilitatorService;
